import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { Text } from '@spotify-internal/encore-web';

export type SidebarSectionTitleProps = ComponentPropsWithoutRef<'h3'>;

const SidebarSectionTitle = forwardRef<
  HTMLHeadingElement,
  SidebarSectionTitleProps
>((props, ref) => {
  const { className, children, ...rest } = props;

  return (
    <Text
      as="h3"
      variant="bodyMediumBold"
      ref={ref}
      className={className}
      {...rest}
    >
      {children}
    </Text>
  );
});

SidebarSectionTitle.displayName = 'SidebarSection.Title';

export default SidebarSectionTitle;
